module.exports = __webpack_public_path__ + "media/images/icons/arrow_left-48804d3670bc93572b464f1b068b9664.svg";